<script>
	import OverviewSection from './OverviewSection.svelte';
	import InpageElementsSection from './InpageElementsSection.svelte';
	import OrdersReportSection from './OrdersReportSection.svelte';
</script>

<div class="dashboard-container">
	<h1>Analytics</h1>
	<OverviewSection />
	<InpageElementsSection />
	<OrdersReportSection />
</div>

<style>
	.dashboard-container {
		max-width: 800px;
		margin: 24px auto;
		display: flex;
		flex-direction: column;
		gap: 40px;
	}
	.dashboard-container :global(*) {
		font-family: Inter;
		color: #101828;
	}

	.dashboard-container :global(.bordered-section) {
		box-shadow: 1px 0px 0px 0px rgba(0, 0, 0, 0.13) inset,
			-1px 0px 0px 0px rgba(0, 0, 0, 0.13) inset, 0px -1px 0px 0px rgba(0, 0, 0, 0.17) inset,
			0px 1px 0px 0px rgba(204, 204, 204, 0.5) inset, 0px 1px 0px 0px rgba(26, 26, 26, 0.07);
		background-color: #fff;
		border-radius: 12px;
		padding: 24px;
		position: relative;
	}
	.dashboard-container :global(h2),
	.dashboard-container :global(h3) {
		color: var(--Typography-Primary, #101828);
		font-family: Inter;
		font-size: 18px;
		font-style: normal;
		font-weight: 700;
		line-height: normal;
		letter-spacing: 0.15px;
	}

	.dashboard-container :global(h3) {
		margin-bottom: 0.5em;
	}

	.dashboard-container :global(button) {
		padding: 8px 16px;
		background-color: #007bff;
		color: #fff;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		margin-top: 16px;
	}
	.dashboard-container :global(button:hover) {
		background-color: #0056b3;
	}
	.dashboard-container :global(.loader) {
		width: 48px;
		height: 48px;
		border: 5px solid #ddd;
		border-bottom-color: transparent;
		border-radius: 50%;
		display: inline-block;
		box-sizing: border-box;
		animation: rotation 1s linear infinite;
		position: absolute;
		top: calc(50% - 24px);
		left: calc(50% - 24px);
	}
	:global(.datepicker) {
		border: 1px solid #999;
		border-radius: 4px;
		padding: 4px;
		display: flex;
		align-items: center;
		white-space: nowrap;
	}
	.dashboard-container :global(nav),
	.dashboard-container :global(.high-level-numbers) {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		gap: 1em;
		margin-bottom: 1em;
	}
	@keyframes rotation {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>
